export enum Constants {
  BONUS_LEVEL_MAX_PERCENT = 0.21,
  LEADERSHIP_BONUS_PERCENT = 0.06,
  FOSTER_BONUS_PERCENT = 0.04,
  RUBY_BONUS_PERCENT = 0.02,
  BRONZE_ELIGIBLE_VALUE = 100,
  BRONZE_MIN_ACTUAL_PPV = 100,
  BRONZE_LEGS_MIN_LENGTH = 3,
  BRONZE_FOUNDATION_BF_PERCENT = 0.09,
  BRONZE_FOUNDATION_3x3_PERCENT_LEGS = 0.03,
  BRONZE_BUILDER_BB_PERCENT = 0.15,
  BRONZE_BUILDER_3x6_PERCENT_LEGS = 0.06,
  DEEP_BONUS_PERCENT = 0.01,
  DEEP_BONUS_CRITERIA_MIN_FRONTLINE_LEGS = 3,
  DEEP_BONUS_CRITERIA_MIN_FRONTLINE_LEGS_LEVEL_2 = 1,

  // Annual PPV
  ANNUAL_PPV_EUROPE = 2400, // Europe Countries - 200 PPV (=2400 PPV Annual)
  ANNUAL_PPV_ANZ = 1800, // Australia & New Zealand - 150 PPV (=1800 PPV Annual)

  // Europe & ANZ Constants
  QMONTH_GROUP_PV_MORE_THAN_ONE_FRONTLINES_EU = 10000,
  QMONTH_GROUP_PV_MORE_THAN_ONE_FRONTLINES_ANZ = 7500,
  QMONTH_GROUP_PV_ONE_FRONTLINE_EU = 4000,
  QMONTH_GROUP_PV_ONE_FRONTLINE_ANZ = 3250,
  RUBY_BONUS_PV_MINIMUM_EU = 19999.99,
  RUBY_BONUS_PV_MINIMUM_ANZ = 14999.99,
  BRONZE_MIN_PERSONAL_PV = 25,

  // Retail Margin
  RETAIL_MARGIN_PERCENT = 0.2,
  RETAIL_MARGIN_PERCENT_ZA = 0.3, // PY27 update (Sep 2026), confirmed by Amway 2026-08-11

  // Performance Plus
  PERFORMANCE_PLUS_PERFORMANCE_BONUS_MONTHLY_MULTIPLIER = 0.40,
  PERFORMANCE_PLUS_DEEP_BONUS_CRITERIA_MIN_FRONTLINE_LEGS = 1,

  // Path to Bronze
  PTB_MIN_LEG_GPV = 100, // a PTB leg is a frontline with >= 100 group PV (all markets)
  PTB_MIN_LEGS = 3,
  PTB_MAX_LEGS = 6,
}

// Europe & ANZ Constants
export const PERFORMANCE_BONUS_SCHEDULE_EU: [number, number][] = [[10000, 0.21], [7000, 0.18], [4000, 0.15], [2400, 0.12], [1200, 0.09], [600, 0.06], [200, 0.03], [0, 0.00]]
export const PERFORMANCE_BONUS_SCHEDULE_ANZ: [number, number][] = [[7500, 0.21], [5000, 0.18], [3250, 0.15], [2000, 0.12], [1000, 0.09], [400, 0.06], [100, 0.03], [0, 0.00]]

// The iterable form of the Path to Bronze tier range (3..6), derived once so the
// calculation and the section never encode the range independently
export const PTB_LEG_TIERS: number[] = Array.from(
  { length: Constants.PTB_MAX_LEGS - Constants.PTB_MIN_LEGS + 1 },
  (_, index) => Constants.PTB_MIN_LEGS + index
)
